import React from 'react'

// third party components

// images and icons
import ShareSmallIcon from 'assets/icons/share-black-menu.svg?component'
import EditIcon from 'assets/icons/edit-icon-22x22.svg?component'
import SaveIcon from 'assets/icons/save-white-icon-12x16.svg?component'
import ImportIcon from 'assets/icons/menu-import-art-icon.svg?component'
import PlusIcon from 'assets/icons/plus-circle-icon.svg?component'
import UploadIcon from 'assets/icons/upload-icon.svg?component'
import TicketWhiteIcon from 'assets/icons/ticket-white-46x46.svg?component'

// styles
import styles from './index.module.scss'

interface CollectionMenuPageProps {
  isOwn: boolean
  saved: boolean
  setOpenShareModal: any
  saveCollection: any
  editCollection: any
  uploadNew: any
  importArtwork: any
  addTokenIds: any
}

const CollectionMenuPage = ({
  isOwn,
  saved,
  setOpenShareModal,
  saveCollection,
  editCollection,
  uploadNew,
  importArtwork,
  addTokenIds,
}: CollectionMenuPageProps) => {
  return (
    <div className={styles.menuArea}>
      <div
        className={`${styles.menuItem}`}
        onClick={() => {
          setOpenShareModal(true)
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <ShareSmallIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>Share Collection</div>
            <div className={styles.itemDescription}>Share to socials or copy link</div>
          </div>
        </div>
      </div>

      {isOwn ? (
        <div>
          <div className={styles.separator} />

          <div
            className={`${styles.menuItem}`}
            onClick={() => {
              editCollection()
            }}
          >
            <div className="flex gap-[15px] items-center">
              <div className={styles.itemIcon}>
                <EditIcon alt="" />
              </div>
              <div>
                <div className={styles.itemTitle}>Edit Collection</div>
                <div className={styles.itemDescription}>Update name, description, or cover image</div>
              </div>
            </div>
          </div>

          <div className={styles.separator} />

          <div
            className={`${styles.menuItem}`}
            onClick={() => {
              uploadNew()
            }}
          >
            <div className="flex gap-[15px] items-center">
              <div className={styles.itemIcon}>
                <UploadIcon alt="" />
              </div>
              <div>
                <div className={styles.itemTitle}>Upload New</div>
                <div className={styles.itemDescription}>Mint new artwork to my collection</div>
              </div>
            </div>
          </div>

          <div className={styles.separator} />

          <div
            className={`${styles.menuItem}`}
            onClick={() => {
              importArtwork()
            }}
          >
            <div className="flex gap-[15px] items-center">
              <div className={styles.itemIcon}>
                <ImportIcon alt="" />
              </div>
              <div>
                <div className={styles.itemTitle}>Import Artwork</div>
                <div className={styles.itemDescription}>Import artwork from other platforms</div>
              </div>
            </div>
          </div>

          <div className={styles.separator} />

          <div
            className={`${styles.menuLastItem}`}
            onClick={() => {
              addTokenIds()
            }}
          >
            <div className="flex gap-[15px] items-center">
              <div className={styles.itemIcon}>
                <PlusIcon alt="" />
              </div>
              <div>
                <div className={styles.itemTitle}>Add Token IDs</div>
                <div className={styles.itemDescription}>Import artwork via token IDs</div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className={styles.separator} />
          <div
            className={`${styles.menuLastItem}`}
            onClick={() => {
              saveCollection()
            }}
          >
            <div className="flex gap-[15px] items-center">
              <div className={styles.itemIcon}>{saved ? <SaveIcon alt="" /> : <TicketWhiteIcon alt="" />}</div>
              <div>
                <div className={styles.itemTitle}>{saved ? 'Unsave' : 'Save'}</div>
                <div className={styles.itemDescription}>
                  {saved ? 'Remove collection from my favorites' : 'Bookmark collection to my favorites'}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CollectionMenuPage
